import { Workbox } from 'workbox-window';

export default function serviceWorkerUpdates() {
  if (process.env.NODE_ENV && 'production' !== process.env.NODE_ENV) return;

  if ('serviceWorker' in Navigator) {
    const wb = Workbox(`${process.env.PUBLIC_URL}/sw.js`);

    wb.addEventListener('installed', async (event) => {
      if (event.isUpdate) {
        // console.log('New version');
        wb.messageSW({ type: 'SKIP_WAITING' });
        const cacheNames = await caches.keys();
        if (cacheNames) {
          // console.log('Existing Caches:', cacheNames);
          cacheNames.then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              if (cacheName.startsWith('domo-crm-bl')) {
                caches.delete(cacheName);
              }
            });
          });
        }
      }
    });

    wb.addEventListener('message', (event) => {
      if (event.data.type === 'CACHE_UPDATED') {
        try {
          // const { updatedURL } = event?.data?.payload;
          // console.log(`A newer version of ${updatedURL} is available!`);
        } catch (error) {
          // console.log(`Error => ${JSON.stringify(error)}`);
        }
      }
    });

    wb.register();
  }
}
